export default "__VITE_ASSET__Cj$IL$R8__"